import { Onboarding } from './types'
import client from '../../client'

export const onboarding = (data: Onboarding) =>
  client.post<Onboarding>('v1/user/first-login/', data)
